import { styled } from '@mui/material'

import { TabPanelLocation } from '@tabeeb/enums'
import { ToggleButton } from '@collaborate-health/uikit'

export const NavbarToggleButton = styled(ToggleButton)(({ theme }) => ({
  height: 48,
  width: 48,

  [`&[data-location="${TabPanelLocation.Left}"]`]: {
    borderLeft: 'none',

    [`&:first-of-type`]: {
      borderTopLeftRadius: 0,
    },

    [`&:last-of-type`]: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 'inherit',
    },
  },

  [`&[data-location="${TabPanelLocation.Right}"]`]: {
    borderRight: 'none',

    [`&:first-of-type`]: {
      borderTopRightRadius: 0,
    },

    [`&:last-of-type`]: {
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 'inherit',
    },
  },

  [`&[data-location="${TabPanelLocation.Bottom}"]`]: {
    borderBottom: 'none',

    [`&:first-of-type`]: {
      borderBottomLeftRadius: 0,
    },

    [`&:last-of-type`]: {
      borderBottomRightRadius: 0,
      borderTopRightRadius: 'inherit',
    },
  },
}))

